import clsx from "clsx";
import type { HTMLAttributes } from "react";
import { forwardRef, useContext } from "react";

import { AlertContext } from "../context";
import { defaultIconMapping } from "../utils";

import styles from "./icon.module.css";

type Props = HTMLAttributes<HTMLDivElement>;

const Icon = forwardRef<HTMLDivElement, Props>(
    ({ children, className, ...props }, ref) => {
        const { severity } = useContext(AlertContext);

        return (
            <div
                ref={ref}
                className={clsx(styles.icon, className)}
                data-severity={severity}
                {...props}
            >
                {children || defaultIconMapping[severity]}
            </div>
        );
    },
);
Icon.displayName = "Icon";

export { Icon };
export type { Props as IconProps };
